// DEV-61. Обращения к серверной половине РГ-06 (сделана 22.09, DEV-51).
//
// Имена полей — по контракту:
//   POST /password-recovery/request { email }
//   POST /password-recovery/confirm { requestId, token, password }

import $api from "../http";

export interface RecoveryRequestAnswer {
  requested: boolean;
  message: string;
}

export interface RecoveryConfirmAnswer {
  passwordChanged: boolean;
}

export default class RecoveryService {
  static async request(email: string): Promise<RecoveryRequestAnswer> {
    const response = await $api.post<RecoveryRequestAnswer>("/password-recovery/request", {
      email,
    });

    return response.data;
  }

  static async confirm(payload: {
    requestId: number;
    token: string;
    password: string;
  }): Promise<RecoveryConfirmAnswer> {
    const response = await $api.post<RecoveryConfirmAnswer>(
      "/password-recovery/confirm",
      payload,
    );

    return response.data;
  }
}
